export default __webpack_public_path__ + "static/media/JobSix12.d81903c3.jpg";